import axios from "axios";
import alert from "@/lang/AlertMessages.js";
import label from "@/lang/StaticLabels.js";
const acntUrl = "finc/api/v1/";

const currencyMonitoringProcessTimeout = 30 * 60 * 1000;
const notProcessedMessage = label.caption.notProcessedMessage;
const isCurrencyMonitoringNotProcessed = (error) => {
  const response = error && error.response;
  const message = response && response.data ? response.data.message : "";
  return (
    !!response &&
    response.status === 400 &&
    typeof message === "string" &&
    message.includes(notProcessedMessage)
  );
};

// const normalizePagedResponse = (body) => {
//   const payload = body ? body.data : null;
//   const rows = Array.isArray(payload)
//     ? payload
//     : payload?.data || payload?.items || [];
//   const totalCount = Array.isArray(payload)
//     ? rows.length
//     : payload?.total ??
//       payload?.totalCount ??
//       body?.total ??
//       body?.totalCount ??
//       rows.length;
//   return { data: rows, totalCount: Number(totalCount) || 0 };
// };

export default {
  // AccountConfig Actions ------------------------------------------------------------------
  getAccountConfig({ dispatch, commit }) {
    axios
      .get(acntUrl + "basic/AccountConfig")
      .then((res) => {
        commit("setAccountConfig", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addAccountConfig({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "basic/AccountConfig", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editAccountConfig({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(acntUrl + "basic/AccountConfig/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteAccountConfig({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(acntUrl + "basic/AccountConfig/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // AccountInfo Actions ------------------------------------------------------------------
  getAccountInfo({ dispatch, commit }, data) {
    axios
      .get(acntUrl + "basic/Account?" + data)
      .then((res) => {
        commit("setAccountInfo", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getAccountInfoCode({ dispatch, commit }, data) {
    axios
      .get(acntUrl + "basic/Account/GetMaxCode?" + data)
      .then((res) => {
        commit("setAccountInfoCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addAccountInfo({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "basic/Account", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editAccountInfo({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(acntUrl + "basic/Account/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteAccountInfo({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(acntUrl + "basic/Account", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  importExcelAccountInfo({ dispatch, commit }, data) {
    commit("setErrorMessage", [], { root: true });
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "basic/Account/ImportAsExcel", data)
      .then((res) => {
        if (res.status === 202) {
          commit("setErrorMessage", res.data.data.data, { root: true });
        } else {
          dispatch(
            "successPOSTHandler",
            {
              server: res,
              message: alert.success.submit,
              redirect: false,
            },
            { root: true },
          );
          commit("setModalVisibility", false, { root: true });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // LastAccount Actions ------------------------------------------------------------------
  getLastAccount({ dispatch, commit }) {
    axios
      .get(acntUrl + "basic/Account/LastAccount")
      .then((res) => {
        commit("setLastAccount", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  editLastAccount({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(acntUrl + "basic/Account/UpdateLastAccount", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // VoucherNoteType Actions ------------------------------------------------------------------
  getVoucherNoteType({ dispatch, commit }) {
    axios
      .get(acntUrl + "basic/VoucherNoteType")
      .then((res) => {
        commit("setVoucherNoteType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addVoucherNoteType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "basic/VoucherNoteType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editVoucherNoteType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(acntUrl + "basic/VoucherNoteType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteVoucherNoteType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(acntUrl + "basic/VoucherNoteType", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // DefaultVoucherDescription Actions ------------------------------------------------------------------
  getDefaultVoucherDescription({ dispatch, commit }) {
    axios
      .get(acntUrl + "basic/DefaultVoucherDescription")
      .then((res) => {
        commit("setDefaultVoucherDescription", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addDefaultVoucherDescription({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "basic/DefaultVoucherDescription", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editDefaultVoucherDescription({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(acntUrl + "basic/DefaultVoucherDescription/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteDefaultVoucherDescription({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(acntUrl + "basic/DefaultVoucherDescription", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  //FinancialRatio Actions ------------------------------------------------------------------
  getFinancialRatio({ dispatch, commit }) {
    axios
      .get(acntUrl + "basic/FinancialRatio")
      .then((res) => {
        commit("setFinancialRatio", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFinancialRatioItem({ dispatch, commit }, data) {
    axios
      .get(acntUrl + "basic/FinancialRatio/" + data)
      .then((res) => {
        commit("setFinancialRatioItem", res.data.data);
        const ratioDetails = res.data.data.financialRatioDetails;
        const numeratorItems = ratioDetails
          .filter((item) => item.isNumerator)
          .map((item) => ({
            accountInfoId: item.accountInfoId,
            accCode: item.accountInfoCode,
            title: item.accountInfoTitle,
          }));
        const denominatorItems = ratioDetails
          .filter((item) => !item.isNumerator)
          .map((item) => ({
            accountInfoId: item.accountInfoId,
            accCode: item.accountInfoCode,
            title: item.accountInfoTitle,
          }));
        commit("setNumerator", numeratorItems);
        commit("setDenominator", denominatorItems);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addFinancialRatio({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "basic/FinancialRatio", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editFinancialRatio({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(acntUrl + "basic/FinancialRatio/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteFinancialRatio({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(acntUrl + "basic/FinancialRatio", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Voucher Actions ------------------------------------------------------------------
  getVouchers({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    return axios
      .get(acntUrl + "operation/Voucher?" + data)
      .then((res) => {
        commit("setVouchers", res.data.data);
        commit("setVouchersTotalCount", res.data.totalCount);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        commit("setVouchers", []);
        commit("setVouchersTotalCount", 0);
        return { data: [], totalCount: 0 };
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getVoucher({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    let id = data && data.id ? data.id : data;
    axios
      .get(acntUrl + "operation/Voucher/" + id)
      .then((res) => {
        commit("setVoucher", res.data.data);
        let found = res.data.data.voucherDetails?.find(
          (z, index) => z.id && index === Number(data.index),
        );
        if (found) {
          commit("setAttachDetailVoucher", found);
        }
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  fetchVoucherForCopy({ dispatch, commit }, id) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    return axios
      .get(acntUrl + "operation/Voucher/" + id)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      })
      .finally(() => {
        commit("setLoading", { status: 0, message: "" }, { root: true });
      });
  },

  getVoucherNavigation({ dispatch, commit }, data) {
    const query = data && typeof data === "object" ? data.query : data;
    const notFoundMessage =
      data && typeof data === "object" ? data.notFoundMessage : null;
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    return axios
      .get(acntUrl + "operation/Voucher/Navigation?" + query)
      .then((res) => {
        const voucher = res.data.data;
        if (!voucher && notFoundMessage) {
          commit("setError", notFoundMessage, { root: true });
          return null;
        }
        commit("setVoucherNavigation", voucher);
        return voucher;
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getVoucherMaxCode({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(acntUrl + "operation/Voucher/MaxCode")
      .then((res) => {
        commit("setVoucherMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getVoucherMaxNumber({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(acntUrl + "operation/Voucher/MaxNumber")
      .then((res) => {
        commit("setVoucherMaxNumber", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getVoucherMaxTempNumber({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(acntUrl + "operation/Voucher/MaxTempNumber")
      .then((res) => {
        commit("setVoucherMaxTempNumber", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addVoucher({ dispatch, commit }, data) {
    setTimeout(() => {
      commit("setLoadingBtn", true, { root: true });
    }, 1300);
    return axios
      .post(acntUrl + "operation/Voucher", data)
      .then((res) => {
        commit("setVoucherId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1300);
      });
  },

  editVoucher({ dispatch, commit }, data) {
    setTimeout(() => {
      commit("setLoadingBtn", true, { root: true });
    }, 1300);
    return axios
      .put(acntUrl + "operation/Voucher/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1300);
      });
  },

  deleteVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(acntUrl + "operation/Voucher", { data })
      .then((res) => {
        commit("setIsDeleteVoucher", true);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        commit("setIsError", true);
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addVoucherCheckCreate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(acntUrl + "operation/Voucher/CreateCheck", data)
      .then((res) => {
        commit("setVoucherCheckCreate", res.data.data);
        dispatch(
          "successPOSTHandlerSilent",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addVoucherCheckUpdate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(acntUrl + "operation/Voucher/UpdateCheck", data)
      .then((res) => {
        commit("setVoucherCheckUpdate", res.data.data);
        dispatch(
          "successPOSTHandlerSilent",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  importAsExcelVoucher({ dispatch, commit }, data) {
    commit("setErrorMessage", [], { root: true });
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "operation/Voucher/ImportAsExcel", data)
      .then((res) => {
        if (res.status === 202) {
          commit("setErrorMessage", res.data.data.data, { root: true });
        } else {
          dispatch(
            "successPOSTHandler",
            {
              server: res,
              message: alert.success.submit,
              redirect: false,
            },
            { root: true },
          );
          commit("setModalVisibility", false, { root: true });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // data شماره سند است، یا { number, fiscalYearId } وقتی سند باید
  // در سال مالی دیگری جست‌وجو شود (مثل سند افتتاحیه سال بعد)
  getLastVoucherInfo({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    const isScoped = data !== null && typeof data === "object";
    const number = isScoped ? data.number : data;
    const headers = {};
    if (isScoped && data.fiscalYearId) headers.fiscalYearId = data.fiscalYearId;
    axios
      .get(acntUrl + "operation/Voucher/Last?number=" + number, { headers })
      .then((res) => {
        commit("setLastVoucherInfo", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getVoucherDateInfo({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(acntUrl + "operation/Voucher/GetVoucherDate?" + data)
      .then((res) => {
        commit("setVoucherInfoDate", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // VoucherAttach Actions ------------------------------------------------------------------
  getVoucherAttaches({ dispatch, commit }, data) {
    axios
      .get(acntUrl + "operation/VoucherAttach?" + data)
      .then((res) => {
        commit("setVoucherAttaches", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addVoucherAttach({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "operation/VoucherAttach", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteVoucherAttach({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(acntUrl + "operation/VoucherAttach", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // VoucherNote Actions ------------------------------------------------------------------
  getVoucherNotes({ dispatch, commit }, data) {
    return axios
      .get(acntUrl + "operation/VoucherNote?voucherDetailId=" + data)
      .then((res) => {
        commit("setVoucherNotes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addVoucherNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(acntUrl + "operation/VoucherNote", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.status === 200;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editVoucherNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .put(acntUrl + "operation/VoucherNote/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.status === 200;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteVoucherNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .delete(acntUrl + "operation/VoucherNote", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.status === 200;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // PersonCredit Actions ------------------------------------------------------------------
  getPersonCredits({ dispatch, commit }) {
    axios
      .get(acntUrl + "basic/PersonCredit")
      .then((res) => {
        commit("setPersonCredits", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addPersonCredit({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "basic/PersonCredit", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPersonCredit({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(acntUrl + "basic/PersonCredit/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePersonCredit({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(acntUrl + "basic/PersonCredit", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // UserLimitAccountInfo Actions ------------------------------------------------------------------
  getUserLimitAccounts({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "operation/UserLimitAccountInfo?userId=" + data)
      .then((res) => {
        commit("setUserLimitAccounts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  ChangeUserLimitAccounts({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(acntUrl + "operation/UserLimitAccountInfo", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteUserLimitAccounts({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(acntUrl + "operation/UserLimitAccountInfo", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Voucher Opertaion Actions ------------------------------------------------------------------
  // voucherSort({ dispatch, commit }, data) {
  //   commit("setLoadingBtn", true, { root: true });
  //   axios
  //     .post(acntUrl + "operation/Voucher/Sort", data)
  //     .then((res) => {
  //       dispatch(
  //         "successPOSTHandler",
  //         {
  //           server: res,
  //           message: res.data.message,
  //           redirect: false,
  //         },
  //         { root: true }
  //       );
  //     })
  //     .catch((error) => {
  //       dispatch("errorPOSTHandler", error, { root: true });
  //     })
  //     .finally(() => {
  //       setTimeout(() => {
  //         commit("setLoadingBtn", false, { root: true });
  //       }, 1000);
  //     });
  // },

  voucherConfirm({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "operation/Voucher/ConfirmDate", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Voucher Cartable Actions ------------------------------------------------------------------
  getPreviewFinalDate({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "operation/finalVoucher/PreviewFinalDate?" + data)
      .then((res) => {
        commit("setPreviewFinalDate", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  ConfirmVoucherFinalDate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "operation/finalVoucher/FinalDate", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getConfirmCartable({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "operation/Voucher/ConfirmCartable?" + data)
      .then((res) => {
        commit("setConfirmCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  ConfirmVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "operation/Voucher/Confirm", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getUnConfirmCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "operation/Voucher/UnConfirmCartable")
      .then((res) => {
        commit("setUnConfirmCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  unConfirmVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "operation/Voucher/UnConfirm", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // Voucher Review Actions ------------------------------------------------------------------
  getVoucherReview({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "operation/VoucherDetail/Review?" + data)
      .then((res) => {
        commit("setVoucherReview", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  deleteVoucherDetail({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(acntUrl + "operation/VoucherDetail", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // EmptyVoucher Actions ------------------------------------------------------------------
  getEmptyVoucher({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "operation/Voucher/DeleteEmptyVoucherCartable")
      .then((res) => {
        commit("setEmptyVoucher", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  deleteEmptyVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "operation/Voucher/DeleteEmptyVoucher", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // ArchiveVoucher Actions ------------------------------------------------------------------
  getArchiveVoucher({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "operation/Voucher/ArchiveCartable?" + data)
      .then((res) => {
        commit("setArchiveVoucher", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  voucherArchive({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "operation/Voucher/Archive", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // DebtorOrCreditorDeclaration Actions ------------------------------------------------------------------
  getDebtorOrCreditorDeclarations({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "operation/DebtorOrCreditorDeclaration")
      .then((res) => {
        commit("setDebtorOrCreditorDeclarations", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getDebtorOrCreditorDeclaration({ dispatch, commit }, data) {
    axios
      .get(acntUrl + "operation/DebtorOrCreditorDeclaration/" + data)
      .then((res) => {
        commit("setDebtorOrCreditorDeclaration", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getDebtorOrCreditorDeclarationCode({ dispatch, commit }) {
    axios
      .get(acntUrl + "operation/DebtorOrCreditorDeclaration/MaxCode")
      .then((res) => {
        commit("setDebtorOrCreditorDeclarationCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getDebtorOrCreditorDeclarationNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(acntUrl + "operation/DebtorOrCreditorDeclaration/Navigation?" + data)
      .then((res) => {
        commit("setDebtorOrCreditorDeclarationNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addDebtorOrCreditorDeclaration({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "operation/DebtorOrCreditorDeclaration", data)
      .then((res) => {
        commit("setDebtorOrCreditorDeclarationId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editDebtorOrCreditorDeclaration({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        acntUrl + "operation/DebtorOrCreditorDeclaration/" + data.id,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteDebtorOrCreditorDeclaration({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(acntUrl + "operation/DebtorOrCreditorDeclaration", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getDebtorOrCreditorDeclarationCheckDelete({ dispatch, commit }, data) {
    axios
      .get(
        acntUrl + "operation/DebtorOrCreditorDeclaration/CheckDelete?" + data,
      )
      .then((res) => {
        commit("setDebtorOrCreditorDeclarationCheckDelete", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getDebtorOrCreditorDeclarationVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(
        acntUrl +
          "operation/DebtorOrCreditorDeclaration/GetAddVoucher?ids=" +
          data,
      )
      .then((res) => {
        commit("setDebtorOrCreditorDeclarationVoucher", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addDebtorOrCreditorDeclarationVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "operation/DebtorOrCreditorDeclaration/AddVoucher", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteDebtorOrCreditorDeclarationVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(acntUrl + "operation/DebtorOrCreditorDeclaration/DeleteVoucher", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // voucher verification ---------------------------------
  getVoucherVerification({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "operation/Voucher/VoucherCartableList?" + data)
      .then((res) => {
        commit("setVoucherVerification", res.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  voucherVerificationChangeStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "operation/Voucher/ChangeStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // CartableLog Actions ------------------------------------------------------------------
  getCartableLog({ dispatch, commit }, data) {
    axios
      .get(acntUrl + "operation/CartableLog?" + data)
      .then((res) => {
        commit("setCartableLog", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Management Cartable ---------------------------------
  getVoucherManagementCartable({ dispatch, commit }, data) {
    axios
      .get(acntUrl + "operation/Voucher/VoucherManagementCartableList?" + data)
      .then((res) => {
        commit("setVoucherManagementCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  voucherManagementCartable({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(acntUrl + "operation/Voucher/ManagementCartable", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //  close accounts ----------------------------------------
  voucherSort({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "operation/CloseAccount/Sort", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getFinalizationDocument({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "operation/CloseAccount/PreviewFinalDate?" + data)
      .then((res) => {
        commit("setFinalizationDocument", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  finalizationDocument({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "operation/CloseAccount/FinalDate", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getUnFinalizationDocument({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "operation/CloseAccount/PreviewFinalDate?" + data)
      .then((res) => {
        commit("setUnFinalizationDocument", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  unFinalizationDocument({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "operation/CloseAccount/FinalDate", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  delTemporaryDocAccounts({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "operation/CloseAccount/delTemporaryDocAccounts", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteFinalDocument({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "operation/CloseAccount/deleteFinalDocument", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getRequiredDate({ dispatch, commit }) {
    axios
      .get(acntUrl + "operation/CloseAccount/GetRequiredDate")
      .then((res) => {
        commit("setRequiredDate", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCloseAccountStep({ dispatch, commit }) {
    axios
      .get(acntUrl + "operation/CloseAccount/GetStep")
      .then((res) => {
        commit("setCloseAccountStep", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPreviewCloseTemporaryAccount({ dispatch, commit }) {
    axios
      .get(acntUrl + "operation/CloseAccount/PreviewCloseTemporaryAccount")
      .then((res) => {
        commit("setPreviewCloseTemporaryAccount", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  closeTemporaryAccount({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "operation/CloseAccount/CloseTemporaryAccount", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // نتیجه برمی‌گردد تا مرحله بعد از حذف سند به مرحله قبل برود
  deleteCloseTemporaryAccount({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(acntUrl + "operation/CloseAccount/DeleteVoucherTemporaryAccount")
      .then((res) => {
        dispatch(
          "successPOSTHandlerSimple",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.status === 200;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPreviewClosePermanentAccount({ dispatch, commit }) {
    axios
      .get(acntUrl + "operation/CloseAccount/PreviewClosePermanentAccount")
      .then((res) => {
        commit("setPreviewClosePermanentAccount", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  openingVoucher({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "operation/CloseAccount/OpeningVoucher", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  closePermanentAccount({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "operation/CloseAccount/ClosePermanentAccount", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // نتیجه برمی‌گردد تا مرحله بعد از حذف سند به مرحله قبل برود
  deleteVoucherPermanentAccount({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(acntUrl + "operation/CloseAccount/DeleteVoucherPermanentAccount")
      .then((res) => {
        dispatch(
          "successPOSTHandlerSimple",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.status === 200;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //report ------------------------------------------------------------------
  getGeneralJournalReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(acntUrl + "acnt/Report/GeneralJournalReport", data)
      .then((res) => {
        commit("setGeneralJournalReport", res.data.data);
        // dispatch(
        //   "successPOSTHandler",
        //   {
        //     server: res,
        //     message: res.data.message,
        //     redirect: false,
        //   },
        //   { root: true }
        // );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getGeneralJournalSummaryReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "acnt/Report/GeneralJournalSummaryReport", data)
      .then((res) => {
        commit("setGeneralJournalSummaryReport", res.data.data);
        // dispatch(
        //   "successPOSTHandler",
        //   {
        //     server: res,
        //     message: res.data.message,
        //     redirect: false,
        //   },
        //   { root: true }
        // );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getAccountOperationDetailReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(acntUrl + "acnt/Report/AccountOperationDetailReport", data)
      .then((res) => {
        commit("setAccountOperationDetailReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getBasedOnSaleManagerListReport({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "Report/ReportOfCreditorsSalesManagers")
      .then((res) => {
        commit("setBasedOnSaleManagerListReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getReportOfCreditorsAndDebtorsBasedOnSalesManagers(
    { dispatch, commit },
    data,
  ) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "Report/ReportOfCreditorsSalesManagers?" + data)
      .then((res) => {
        commit(
          "setReportOfCreditorsAndDebtorsBasedOnSalesManagers",
          res.data.data.items,
        );
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getOperationalLedgerAccountTurnoverReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(acntUrl + "acnt/Report/OperationalLedgerAccountTurnover", data)
      .then((res) => {
        commit("setOperationalLedgerAccountTurnoverReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPersonOperationDetailReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(acntUrl + "acnt/Report/PersonOperationDetail", data)
      .then((res) => {
        commit("setPersonOperationDetailReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPersonOperationDetailSalt({ dispatch, commit }, data) {
    return axios
      .post(acntUrl + "acnt/Report/PersonOperationDetailSalt", data)
      .then((res) => {
        const result = res.data ? res.data.data : null;
        commit("setPersonOperationDetailSalt", result);
        return result;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        commit("setPersonOperationDetailSalt", null);
        return null;
      });
  },
  getTrialBalance4ColumnsReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "acnt/Report/TrialBalance4ColumnReport", data)
      .then((res) => {
        commit("setTrialBalance4ColumnsReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getDetailTrialBalance4ColumnsReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(
        acntUrl + "acnt/Report/DetailTrialBalance4ColumnBySixOperationReport",
        data,
      )
      .then((res) => {
        commit("setDetailTrialBalance4ColumnsReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getTrialBalance6ColumnsReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "acnt/Report/TrialBalance6ColumnReport", data)
      .then((res) => {
        commit("setTrialBalance6ColumnsReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getDetailTrialBalance6ColumnsReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(
        acntUrl + "acnt/Report/DetailTrialBalance6ColumnBySixOperationReport",
        data,
      )
      .then((res) => {
        commit("setDetailTrialBalance6ColumnsReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getTrialBalance8ColumnsReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(acntUrl + "acnt/Report/TrialBalance8ColumnReport", data)
      .then((res) => {
        commit("setTrialBalance8ColumnsReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getDetailTrialBalance8ColumnsReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(
        acntUrl + "acnt/Report/DetailTrialBalance8ColumnBySixOperationReport",
        data,
      )
      .then((res) => {
        commit("setDetailTrialBalance8ColumnsReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getAccountWithPersonReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/AccountWithPerson", data)
      .then((res) => {
        commit("setAccountWithPersonReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount1OperationDetail({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(acntUrl + "acnt/Report/FloatAccount1OperationDetail", data)
      .then((res) => {
        commit("setFloatAccount1OperationDetail", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount2OperationDetail({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/FloatAccount2OperationDetail", data)
      .then((res) => {
        commit("setFloatAccount2OperationDetail", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount3OperationDetail({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/FloatAccount3OperationDetail", data)
      .then((res) => {
        commit("setFloatAccount3OperationDetail", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount4OperationDetail({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/FloatAccount4OperationDetail", data)
      .then((res) => {
        commit("setFloatAccount4OperationDetail", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount5OperationDetail({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/FloatAccount5OperationDetail", data)
      .then((res) => {
        commit("setFloatAccount5OperationDetail", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccountTextOperationDetail({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/FloatAccountTextOperationDetail", data)
      .then((res) => {
        commit("setFloatAccountTextOperationDetail", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getAccountWithFloatAccount1({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/AccountWithFloatAccount1", data)
      .then((res) => {
        commit("setAccountWithFloatAccount1", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getAccountWithFloatAccount2({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/AccountWithFloatAccount2", data)
      .then((res) => {
        commit("setAccountWithFloatAccount2", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getAccountWithFloatAccount3({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/AccountWithFloatAccount3", data)
      .then((res) => {
        commit("setAccountWithFloatAccount3", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getAccountWithFloatAccount4({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/AccountWithFloatAccount4", data)
      .then((res) => {
        commit("setAccountWithFloatAccount4", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getAccountWithFloatAccount5({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/AccountWithFloatAccount5", data)
      .then((res) => {
        commit("setAccountWithFloatAccount5", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getAccountWithFloatAccountText({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/AccountWithFloatAccountText", data)
      .then((res) => {
        commit("setAccountWithFloatAccountText", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getAccountWithFloatAccountGroupReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/AccountWithFloatAccountGroupReport", data)
      .then((res) => {
        commit("setAccountWithFloatAccountGroupReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount1WithPerson({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/FloatAccount1WithPerson", data)
      .then((res) => {
        commit("setFloatAccount1WithPerson", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount2WithPerson({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/FloatAccount2WithPerson", data)
      .then((res) => {
        commit("setFloatAccount2WithPerson", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount3WithPerson({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/FloatAccount3WithPerson", data)
      .then((res) => {
        commit("setFloatAccount3WithPerson", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount4WithPerson({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/FloatAccount4WithPerson", data)
      .then((res) => {
        commit("setFloatAccount4WithPerson", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount5WithPerson({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/FloatAccount5WithPerson", data)
      .then((res) => {
        commit("setFloatAccount5WithPerson", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccountTextWithPerson({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/FloatAccountTextWithPerson", data)
      .then((res) => {
        commit("setFloatAccountTextWithPerson", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getFloatAccount1WithAccount({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/FloatAccount1WithAccount", data)
      .then((res) => {
        commit("setFloatAccount1WithAccount", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount2WithAccount({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/FloatAccount2WithAccount", data)
      .then((res) => {
        commit("setFloatAccount2WithAccount", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount3WithAccount({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/FloatAccount3WithAccount", data)
      .then((res) => {
        commit("setFloatAccount3WithAccount", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount4WithAccount({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(acntUrl + "acnt/Report/FloatAccount4WithAccount", data)
      .then((res) => {
        commit("setFloatAccount4WithAccount", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount5WithAccount({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(acntUrl + "acnt/Report/FloatAccount5WithAccount", data)
      .then((res) => {
        commit("setFloatAccount5WithAccount", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccountTextWithAccount({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(acntUrl + "acnt/Report/FloatAccountTextWithAccount", data)
      .then((res) => {
        commit("setFloatAccountTextWithAccount", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getStatusDocumentReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "acnt/Report/StatusDocumentReport?" + data)
      .then((res) => {
        commit("setStatusDocumentReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getTrialBalanceReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(acntUrl + "acnt/Report/TrialBalanceReport", data)
      .then((res) => {
        commit("setTrialBalanceReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPersonWithFloatAccount1({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/PersonWithFloatAccount1", data)
      .then((res) => {
        commit("setPersonWithFloatAccount1", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPersonWithFloatAccount2({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/PersonWithFloatAccount2", data)
      .then((res) => {
        commit("setPersonWithFloatAccount2", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPersonWithFloatAccount3({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/PersonWithFloatAccount3", data)
      .then((res) => {
        commit("setPersonWithFloatAccount3", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPersonWithFloatAccount4({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/PersonWithFloatAccount4", data)
      .then((res) => {
        commit("setPersonWithFloatAccount4", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPersonWithFloatAccount5({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/PersonWithFloatAccount5", data)
      .then((res) => {
        commit("setPersonWithFloatAccount5", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPersonWithFloatAccountText({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(acntUrl + "acnt/Report/PersonWithFloatAccountText", data)
      .then((res) => {
        commit("setPersonWithFloatAccountText", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPersonWithAccount({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .post(acntUrl + "acnt/Report/PersonWithAccount", data)
      .then((res) => {
        commit("setPersonWithAccount", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPersonCreditsReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "acnt/Report/PersonCreditsReport?" + data)
      .then((res) => {
        commit("setPersonCreditsReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPersonalAccountBalanceReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(acntUrl + "acnt/Report/PersonalAccountBalanceReport", data)
      .then((res) => {
        commit("setPersonalAccountBalanceReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getBalanceReportPersonsList({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(acntUrl + "acnt/Report/BalanceReportPersonsList", data)
      .then((res) => {
        commit("setBalanceReportPersonsList", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getElectronicLedgerReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "acnt/Report/ElectronicLedgerReport?" + data)
      .then((res) => {
        commit("setElectronicLedgerReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })

      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getElectronicLedgerExportData({ dispatch, commit }, data) {
    axios
      .get(
        acntUrl +
          "acnt/Report/ElectronicLedgerExportData?IsCurrency=false" +
          data,
      )
      .then((res) => {
        commit("setElectronicLedgerExportData", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  getPersonFinalVoucherReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "acnt/Report/PersonFinalVoucherReport?" + data)
      .then((res) => {
        commit("setPersonFinalVoucherReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPersonOfficeReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(acntUrl + "acnt/Report/PersonOfficeReport", data)
      .then((res) => {
        commit("setPersonOfficeReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPersonMultiLevelLedgerReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(acntUrl + "acnt/Report/PersonMultiLevelLedgerReport", data)
      .then((res) => {
        commit("setPersonMultiLevelLedgerReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getAccountTreeReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "acnt/Report/AccountTreeReport?" + data)
      .then((res) => {
        commit("setAccountTreeReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getFloatAccount1BalanceTreeReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(
        acntUrl + "acnt/Report/FloatAccount1BalanceAccountTreeReport?" + data,
      )
      .then((res) => {
        commit("setFloatAccount1BalanceTreeReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getFloatAccount2BalanceTreeReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(
        acntUrl + "acnt/Report/FloatAccount2BalanceAccountTreeReport?" + data,
      )
      .then((res) => {
        commit("setFloatAccount2BalanceTreeReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getFloatAccount3BalanceTreeReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(
        acntUrl + "acnt/Report/FloatAccount3BalanceAccountTreeReport?" + data,
      )
      .then((res) => {
        commit("setFloatAccount3BalanceTreeReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getFloatAccount4BalanceTreeReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(
        acntUrl + "acnt/Report/FloatAccount4BalanceAccountTreeReport?" + data,
      )
      .then((res) => {
        commit("setFloatAccount4BalanceTreeReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getFloatAccount5BalanceTreeReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(
        acntUrl + "acnt/Report/FloatAccount5BalanceAccountTreeReport?" + data,
      )
      .then((res) => {
        commit("setFloatAccount5BalanceTreeReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccountTextBalanceTreeReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(
        acntUrl +
          "acnt/Report/FloatAccountTextBalanceAccountTreeReport?" +
          data,
      )
      .then((res) => {
        commit("setFloatAccountTextBalanceTreeReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount1BalanceReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "acnt/Report/FloatAccount1BalanceReport?" + data)
      .then((res) => {
        commit("setFloatAccount1BalanceReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount2BalanceReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .get(acntUrl + "acnt/Report/FloatAccount2BalanceReport?" + data)
      .then((res) => {
        commit("setFloatAccount2BalanceReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount3BalanceReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .get(acntUrl + "acnt/Report/FloatAccount3BalanceReport?" + data)
      .then((res) => {
        commit("setFloatAccount3BalanceReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount4BalanceReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .get(acntUrl + "acnt/Report/FloatAccount4BalanceReport?" + data)
      .then((res) => {
        commit("setFloatAccount4BalanceReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount5BalanceReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "acnt/Report/FloatAccount5BalanceReport?" + data)
      .then((res) => {
        commit("setFloatAccount5BalanceReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccountTextBalanceReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "acnt/Report/FloatAccountTextBalanceReport?" + data)
      .then((res) => {
        commit("setFloatAccountTextBalanceReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getReviewAccounts({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(acntUrl + "acnt/Report/ReviewAccount", data)
      .then((res) => {
        commit("setReviewAccounts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getMonthlyAccountingVoucherReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .get(acntUrl + "acnt/Report/MonthlyAccountingVoucherReport?" + data)
      .then((res) => {
        commit("setMonthlyAccountingVoucherReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getMonthlyAccountingVoucherExportData({ dispatch, commit }, data) {
    axios
      .get(
        acntUrl +
          "acnt/Report/monthlyAccountingVoucherExportData?IsCurrency=false" +
          data,
      )
      .then((res) => {
        commit("setMonthlyAccountingVoucherExportData", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  getFloatAccount1Office({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "acnt/Report/FloatAccount1Office?" + data)
      .then((res) => {
        commit("setFloatAccount1Office", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount2Office({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "acnt/Report/FloatAccount2Office?" + data)
      .then((res) => {
        commit("setFloatAccount2Office", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount3Office({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .get(acntUrl + "acnt/Report/FloatAccount3Office?" + data)
      .then((res) => {
        commit("setFloatAccount3Office", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount4Office({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .get(acntUrl + "acnt/Report/FloatAccount4Office?" + data)
      .then((res) => {
        commit("setFloatAccount4Office", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount5Office({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );

    axios
      .get(acntUrl + "acnt/Report/FloatAccount5Office?" + data)
      .then((res) => {
        commit("setFloatAccount5Office", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccountTextOffice({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "acnt/Report/FloatAccountTextOffice?" + data)
      .then((res) => {
        commit("setFloatAccountTextOffice", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getAccountOfficeReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(acntUrl + "acnt/Report/AccountOfficeReport", data)
      .then((res) => {
        commit("setAccountOfficeReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getProfitAndLossIncomesReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(acntUrl + "acnt/Report/ProfitAndLossReport", data)
      .then((res) => {
        commit("setProfitAndLossIncomesReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPrintProfitAndLossReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintProfitAndLossReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getProfitAndLossCostsReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(acntUrl + "acnt/Report/ProfitAndLossReport", data)
      .then((res) => {
        commit("setProfitAndLossCostsReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getBalanceSheetReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(acntUrl + "acnt/Report/BalanceSheetReport", data)
      .then((res) => {
        commit("setBalanceSheetReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getFinancialRatioReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "acnt/Report/FinancialRatioReport?" + data)
      .then((res) => {
        commit("setFinancialRatioReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPrintFinancialRatioReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFinancialRatioReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // VoucherDetail Actions ------------------------------------------------------------------
  getVoucherDetail({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "operation/VoucherDetail?" + data)
      .then((res) => {
        commit("setVoucherDetail", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  groupTransfer({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(acntUrl + "operation/VoucherDetail", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  changeControl({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(acntUrl + "operation/VoucherDetail/ChangeIsChecked", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //prints
  getPrintVoucherLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(acntUrl + "operation/Voucher/PrintVoucher", data)
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintAccountOperationDetailReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintAccountOperationDetailReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintPersonOperationDetailLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintPersonOperationDetail/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintAccountWithPersonLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintAccountWithPerson/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintPersonWithAccountLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintPersonWithAccount/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintPersonOfficeReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintPersonOfficeReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintPersonMultiLevelLedgerReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintPersonMultiLevelLedgerReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPrintTrialBalance4ColumnReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintTrialBalance4ColumnReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintTrialBalance6ColumnReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintTrialBalance6ColumnReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintTrialBalance8ColumnReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintTrialBalance8ColumnReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintTrialBalanceReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintTrialBalanceReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPrintFloatAccount1OperationDetailLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount1OperationDetail/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintFloatAccount2OperationDetailLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount2OperationDetail/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintFloatAccount3OperationDetailLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount3OperationDetail/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintFloatAccount4OperationDetailLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount4OperationDetail/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintFloatAccount5OperationDetailLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount5OperationDetail/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintFloatAccountTextOperationDetailLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccountTextOperationDetail/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getAccountWithFloatAccount1Log({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintAccountWithFloatAccount1/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getAccountWithFloatAccount2Log({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintAccountWithFloatAccount2/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getAccountWithFloatAccount3Log({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintAccountWithFloatAccount3/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getAccountWithFloatAccount4Log({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintAccountWithFloatAccount4/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getAccountWithFloatAccount5Log({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintAccountWithFloatAccount5/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getAccountWithFloatAccountTextLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintAccountWithFloatAccountText/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getAccountWithFloatAccountGroupReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl +
          "acnt/Report/PrintAccountWithFloatAccountGroupReport/" +
          data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount1WithAccountReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount1WithAccount/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount2WithAccountReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount2WithAccount/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount3WithAccountReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount3WithAccount/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount4WithAccountReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount4WithAccount/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccount5WithAccountReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount5WithAccount/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getFloatAccountTextWithAccountReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccountTextWithAccount/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPrintPersonWithFloatAccount1Log({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintPersonWithFloatAccount1/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintPersonWithFloatAccount2Log({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintPersonWithFloatAccount2/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintPersonWithFloatAccount3Log({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintPersonWithFloatAccount3/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintPersonWithFloatAccount4Log({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintPersonWithFloatAccount4/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintPersonWithFloatAccount5Log({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintPersonWithFloatAccount5/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintPersonWithFloatAccountTextLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintPersonWithFloatAccountText/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintFloatAccount1WithPersonLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount1WithPerson/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintFloatAccount2WithPersonLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount2WithPerson/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintFloatAccount3WithPersonLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount3WithPerson/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintFloatAccount4WithPersonLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount4WithPerson/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintFloatAccount5WithPersonLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount5WithPerson/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintFloatAccountTextWithPersonLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccountTextWithPerson/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintFloatAccount1BalanceReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount1BalanceReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintFloatAccount2BalanceReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount2BalanceReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintFloatAccount3BalanceReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount3BalanceReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintFloatAccount4BalanceReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount4BalanceReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintFloatAccount5BalanceReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount5BalanceReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintFloatAccountTextBalanceReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccountTextBalanceReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPrintFloatAccount1OfficeReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount1Office/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPrintFloatAccount2OfficeReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount2Office/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPrintFloatAccount3OfficeReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount3Office/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPrintFloatAccount4OfficeReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount4Office/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPrintFloatAccount5OfficeReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccount5Office/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintFloatAccountTextOfficeReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintFloatAccountTextOffice?reportId=" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPrintOperationalLedgerAccountTurnoverReportLog(
    { dispatch, commit },
    data,
  ) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl +
          "acnt/Report/PrintOperationalLedgerAccountTurnover/" +
          data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintGeneralJournalReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintGeneralJournalReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintAccountOfficeReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintAccountOfficeReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintPersonCreditsReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintPersonCreditsReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintBalanceReportPersonsListLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintBalanceReportPersonsList/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getPrintPersonFinalVoucherReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintPersonFinalVoucherReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getVoucherNotesReport({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "acnt/Report/VoucherNotes?" + data)
      .then((res) => {
        commit("setVoucherNotesReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // DashboardAccountOffice Actions ------------------------------------------------------------------
  getDashboardAccountOffice({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "acnt/Dashboard/AccountOffice?" + data)
      .then((res) => {
        commit("setDashboardAccountOffice", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addDashboardAccountOffice({ dispatch, commit }, data) {
    axios
      .post(acntUrl + "acnt/Dashboard/DetailAccountOffice", data)
      .then((res) => {
        commit("setDashboardAccountOfficeChart", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  // AccountCurrencyMonitoringReport Actions -----------------------------------
  processAccountCurrencyMonitoringReport({ dispatch, commit }, data) {
    return axios
      .post(
        acntUrl + "acnt/Report/ProcessAccountCurrencyMonitoringReport",
        data,
        { timeout: currencyMonitoringProcessTimeout },
      )
      .then((res) => {
        commit("setAccountCurrencyMonitoringProcess", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      });
  },

  getAccountCurrencyMonitoringReportProgress({ dispatch, commit }, data) {
    const processId = data && data.processId ? data.processId : null;
    return axios
      .get(
        acntUrl +
          "acnt/Report/AccountCurrencyMonitoringReportProgress" +
          (processId ? "?processId=" + processId : ""),
      )
      .then((res) => {
        commit("setAccountCurrencyMonitoringProcess", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        if (isCurrencyMonitoringNotProcessed(error)) {
          commit("setAccountCurrencyMonitoringProcess", null);
          return null;
        }
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  cancelAccountCurrencyMonitoringReport({ dispatch, commit }, data) {
    return axios
      .post(acntUrl + "acnt/Report/CancelAccountCurrencyMonitoringReport", data)
      .then((res) => {
        commit("setAccountCurrencyMonitoringProcess", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      });
  },

  getAccountCurrencyMonitoringReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(acntUrl + "acnt/Report/AccountCurrencyMonitoringReport", data)
      .then((res) => {
        commit("setAccountCurrencyMonitoringReport", res.data.data);
        if (res.data.data && res.data.data.process) {
          commit("setAccountCurrencyMonitoringProcess", res.data.data.process);
        }
        return res.data.data;
      })
      .catch((error) => {
        commit("setAccountCurrencyMonitoringReport", {});
        if (isCurrencyMonitoringNotProcessed(error)) {
          commit("setAccountCurrencyMonitoringProcess", null);
          return null;
        }
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getAccountCurrencyMonitoringReportDetail({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(acntUrl + "acnt/Report/AccountCurrencyMonitoringReportDetail", data)
      .then((res) => {
        commit("setAccountCurrencyMonitoringReportDetail", res.data.data);
        return res.data.data;
      })
      .catch((error) => {
        commit("setAccountCurrencyMonitoringReportDetail", {});
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintAccountCurrencyMonitoringReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl + "acnt/Report/PrintAccountCurrencyMonitoringReport/" + data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // AccountCurrencyTrialBalanceReport Actions ---------------------------------
  getAccountCurrencyTrialBalanceReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(acntUrl + "acnt/Report/AccountCurrencyTrialBalanceReport", data)
      .then((res) => {
        commit("setAccountCurrencyMonitoringNotProcessed", false);
        commit("setAccountCurrencyTrialBalanceReport", res.data.data);
        if (res.data.data && res.data.data.process) {
          commit("setAccountCurrencyMonitoringProcess", res.data.data.process);
        }
        return res.data.data;
      })
      .catch((error) => {
        commit("setAccountCurrencyTrialBalanceReport", {});
        if (isCurrencyMonitoringNotProcessed(error)) {
          commit("setAccountCurrencyMonitoringNotProcessed", true);
          commit("setAccountCurrencyMonitoringProcess", null);
          return null;
        }
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrintAccountCurrencyTrialBalanceReportLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .post(
        acntUrl +
          "acnt/Report/PrintAccountCurrencyTrialBalanceReport/" +
          data.id,
        data.value,
      )
      .then((res) => {
        commit("setPrintLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // VoucherMerge Actions ------------------------------------------------------------------
  getVoucherMerge({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "operation/Voucher/MergeList?" + data)
      .then((res) => {
        commit("setVoucherMerge", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getVoucherMergeDetails({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(acntUrl + "operation/Voucher/MergeDetails/" + data)
      .then((res) => {
        commit("setVoucherMergeDetails", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addVoucherMerge({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    commit("setVoucherMergeResult", []);
    axios
      .post(acntUrl + "operation/Voucher/Merge", data)
      .then((res) => {
        commit("setVoucherMergeResult", res.data.data || []);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
};
